<template>
  <v-card tile>
    <v-card-title class="pl-0">
      <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>个人总览
    </v-card-title>
    <v-card-text>

      <v-card outlined class="rounded-0">
        <v-card-subtitle>
          <span class="font-weight-bold">基础信息</span>
          <v-icon color="primary" class="ml-2" @click="onEdit">mdi-square-edit-outline</v-icon>
        </v-card-subtitle>
        <v-card-text>
          <v-row v-if="!editFlag">
            <v-col cols="12">手机号: {{userBillData.mobile}}</v-col>
            <v-col cols="12">姓名: {{userBillData.name}}</v-col>
            <v-col cols="12">邮箱: {{userBillData.email}}</v-col>
            <v-col cols="12">工作单位: {{userBillData.workUnit}}</v-col>
            <v-col cols="12">兴趣标签: {{userBillData.tags}}</v-col>
          </v-row>
          <v-row dense v-else align="end">
            <v-col cols="6">
              <v-form ref="userInfoForm">
                <int-editor dense outlined class="rounded-0" disabled v-model="editBillData.mobile" label="手机号"></int-editor>
                <v-text-field dense outlined class="rounded-0" v-model="editBillData.name" :rules="[rules.required]" label="姓名"></v-text-field>
                <v-text-field dense outlined class="rounded-0" v-model="editBillData.email" :rules="[rules.email]" label="邮箱"></v-text-field>
                <v-text-field dense outlined class="rounded-0" v-model="editBillData.workUnit" label="工作单位"></v-text-field>
                <v-row dense align="center">
                  <v-col cols="auto">兴趣标签:</v-col>
                  <v-col>
                    <v-chip-group column multiple v-model="selectedTags" active-class="primary">
                      <v-chip small v-for="(item,index) in tags" :close="item.default===false" @click:close="onTagRemove(index)" :key="index">
                        {{item.name}}
                      </v-chip>
                      <mini-text-editor v-if="tagAddFlag" v-focus ref="tagAddEditor" @change="onTagAddOk" width="48" class="mt-1"></mini-text-editor>
                      <a v-if="!tagAddFlag" class="caption ml-2 mt-2" @click="onTagAdd">添加</a>
                    </v-chip-group>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
            <v-col cols="12">
              <v-btn color="primary" v-one-click @click="onEditOk">确定</v-btn>
              <v-btn color="primary" class="ml-2" text @click="onEditCancel">取消</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-row class="mt-4">

        <!-- 项目数统计 -->
        <v-col cols="2">
          <v-card :outlined="stsOutlined" class="rounded-0" :height="stsHeight">
            <v-card-subtitle class="font-weight-bold">项目总数</v-card-subtitle>
            <v-card-text class="text-center">
              <span class="text-h2 font-weight-bold primary--text">{{stat.projectNum}}</span>
              <span class="ml-2 text-h6">个</span>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- 存储空间统计 -->
        <v-col cols="2">
          <v-card :outlined="stsOutlined" class="rounded-0" :height="stsHeight">
            <v-card-subtitle class="font-weight-bold">存储空间</v-card-subtitle>
            <v-card-text class="text-center">
              <span class="text-h2 font-weight-bold warning--text">{{stat.reportSpace}}</span>
              <span class="ml-2 text-h6">{{stat.reportSpaceUnit||'M'}}</span>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- 总分析次数 -->
        <v-col cols="2">
          <v-card :outlined="stsOutlined" class="rounded-0" :height="stsHeight">
            <v-card-subtitle class="font-weight-bold">分析次数</v-card-subtitle>
            <v-card-text class="text-center">
              <span class="text-h2 font-weight-bold primary--text">{{stat.taskNum}}</span>
              <span class="ml-2 text-h6">次</span>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- 分析工具统计 -->
        <v-col cols="2">
          <v-card :outlined="stsOutlined" class="rounded-0" :height="stsHeight">
            <v-card-subtitle class="font-weight-bold">分析工具统计</v-card-subtitle>
            <v-card-text>
              <v-row dense>
                <v-col cols="5" class="text-center">收藏数</v-col>
                <v-col cols="2" class="text-center">vs</v-col>
                <v-col cols="5" class="text-center">使用数</v-col>
              </v-row>
              <v-divider />
              <v-row dense>
                <v-col cols="5" class="text-center primary--text text-h6">{{stat.toolFavNum}}</v-col>
                <v-col cols="2" class="text-center primary--text text-h6">:</v-col>
                <v-col cols="5" class="text-center primary--text text-h6">{{stat.toolUseNum}}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- 消息总数 -->
        <v-col cols="2">
          <v-card :outlined="stsOutlined" class="rounded-0" :height="stsHeight">
            <v-card-subtitle class="font-weight-bold">消息总数</v-card-subtitle>
            <v-card-text class="text-center">
              <span class="text-h2 font-weight-bold warning--text">{{stat.messageNum}}</span>
              <span class="ml-2 text-h6">个</span>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- 留言总数 -->
        <v-col cols="2">
          <v-card :outlined="stsOutlined" class="rounded-0" :height="stsHeight">
            <v-card-subtitle class="font-weight-bold">留言反馈</v-card-subtitle>
            <v-card-text class="text-center">
              <span class="text-h2 font-weight-bold warning--text">{{stat.qaNum}}</span>
              <span class="ml-2 text-h6">次</span>
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>

    </v-card-text>
  </v-card>
</template>
<script>
import { getUserProfile, updateUserInfo, getCoder, getUserStat, userProjectList } from '@/plugins/api';
import { required, email } from '@/plugins/rules';
import { mapState } from 'vuex';

export default {
  data () {
    return {
      stsHeight: 128,
      stsFlat: true,
      stsOutlined: true,
      userBillData: {},
      editFlag: false,
      editBillData: {},
      rules: { required: required(), email: email() },

      coder_CLOUD_TAGS: [], // 系统内置标签
      tags: [],
      tagAddFlag: false,
      selectedTags: [],

      stat: { projectNum: '-', taskNum: '-', messageNum: '-', reportSpace: '-', qaNum: '-', toolFavNum: '-', toolUseNum: '-' } // 用户统计信息
    }
  },
  computed: {
    ...mapState({
      username: state => state.username
    })
  },
  created () { this.init() },
  methods: {
    init () {
      getUserProfile().then((res) => this.userBillData = res.data);
      getCoder(['CLOUD_TAGS']).then(res => this.coder_CLOUD_TAGS = res.data && res.data['CLOUD_TAGS']);
      this.initStat();
    },
    onEdit () {
      this.editBillData = { ...this.userBillData };
      let userTags = this.editBillData.tags && this.editBillData.tags.split(',') || [];
      let tags = this.Utility.clone(this.coder_CLOUD_TAGS);
      this.selectedTags = [];
      if (userTags.length) {
        for (let i = 0, l = userTags.length; i < l; i++) {
          let tagName = userTags[i];
          let coderTag = this.coder_CLOUD_TAGS.find(item => item.name == tagName);
          let index;
          if (!coderTag) {
            tags.push({ code: tagName, name: tagName, default: false });
            index = tags.length - 1;
          } else index = this.coder_CLOUD_TAGS.indexOf(coderTag);
          this.selectedTags.push(index);
        }
      }
      this.tags = tags;
      this.editFlag = true;
    },
    onEditCancel () {
      this.editFlag = false;
    },
    onEditOk () {
      if (!this.$refs.userInfoForm.validate()) return;
      let tags = [];
      this.selectedTags.forEach(index => tags.push(this.tags[index].name));
      this.editBillData.tags = tags.join(',');
      updateUserInfo(this.editBillData).then(() => {
        this.$message.success('修改成功');
        this.userBillData = Object.assign(this.userBillData, this.editBillData);
        this.$store.commit('setUsername', this.userBillData.name);
        this.editFlag = false;
      })
    },

    onTagAdd () {
      this.tagAddFlag = true;
    },
    onTagAddOk (value) {
      if (value) {
        let fr = this.tags.find(item => item.name == value);
        if (fr) {
          let index = this.tags.indexOf(fr);
          if (this.selectedTags.indexOf(index) == -1) this.selectedTags.push(index);
        } else {
          let tag = { code: value, name: value, default: false };
          this.tags.push(tag);
          this.selectedTags.push(this.tags.length - 1);
        }
      }
      this.tagAddFlag = false;
    },
    onTagRemove (index) {
      this.tags.splice(index, 1);
      let selectedIndex = this.selectedTags.indexOf(index);
      if (selectedIndex != -1) {
        this.selectedTags.splice(selectedIndex, 1);
      }
      for (let i = 0, l = this.selectedTags.length; i < l; i++) {
        let idx = this.selectedTags[i];
        if (idx > index) this.selectedTags.splice(i, 1, idx - 1);
      }
    },
    initStat () {
      // 用户项目总数
      userProjectList().then(res => this.stat.projectNum = res.data)
      // 用户分析次数
      getUserStat().then(res => {
        let d = res.data;
        if (d.taskNum) this.stat.taskNum = d.taskNum;
        if (d.toolFavNum) this.stat.toolFavNum = d.toolFavNum;
        if (d.toolUseNum) this.stat.toolUseNum = d.toolUseNum;
        if (d.messageNum) this.stat.messageNum = d.messageNum;
        if (d.qaNum) this.stat.qaNum = d.qaNum;
        if (d.reportSpace) {
          let _reportSpace = parseInt(d.reportSpace / 1024 / 1024);
          if (_reportSpace > 10000) {
            _reportSpace = parseInt(_reportSpace / 1024);
            this.stat.reportSpaceUnit = 'G';
          }
          this.stat.reportSpace = _reportSpace;
        }
      })
    }

  }
}
</script>